<script>
  let {
    value = $bindable(0),
    label,
    error,
    help,
    name,
    min,
    max,
    step,
    required = false,
    disabled = false
  } = $props()
  // Unique per instance: a drawer's fields share names with the page form behind it.
  const uid = $props.id()
  const fieldId = `${name}-${uid}`
</script>

<fieldset class="fieldset">
  <legend class="fieldset-legend">{label}{#if required}<span class="text-error"> *</span>{/if}</legend>
  <input
    type="number"
    id={fieldId}
    {name}
    bind:value
    class="input w-full"
    class:input-error={!!error}
    {min}
    {max}
    {step}    {disabled}
  />
  {#if help && !error}<p class="label whitespace-normal">{help}</p>{/if}
  {#if error}<p class="text-error text-sm mt-1">{Array.isArray(error) ? error[0] : error}</p>{/if}
</fieldset>
